import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalConfig } from '../../models/modal.config';
import { ModalConfigHelper } from '../../helpers/modal-config-helper';
import { Observable, of } from 'rxjs';
import { AppModalComponent } from '../app-modal/app-modal.component';
import { FormGroup } from '@angular/forms';
import { addContactUsForm, contactUsValidationMessages } from '../../forms/contact-us.form';
import { getControlValidationMessage } from '../../helpers/form-helper';
import { AppSharedService } from '../../services/app.service';
import { UiStateStore } from '../../store/ui-state-store.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  modalConfig: ModalConfig;
  contactUsModalConfig: ModalConfig;
  aboutConfig: ModalConfig;
  teamConfig: ModalConfig;
  contactUsForm: FormGroup;
  isFormSubmitted = false;
  @ViewChild("privacyModal") private modalComponent: AppModalComponent;
  @ViewChild("contactusModal") private contactUsComponent: AppModalComponent;
  @ViewChild("aboutModal") private aboutComponent: AppModalComponent;
  @ViewChild("teamModal") private teamComponent: AppModalComponent;

  constructor(private appService: AppSharedService,
    private uiState: UiStateStore) {
    this.contactUsForm = addContactUsForm();
    this.modalConfig = ModalConfigHelper.getPrivacyModalConfig(this.onDismiss);
    this.contactUsModalConfig = ModalConfigHelper.getContactUsModalConfig(this.onDismiss);
    this.teamConfig = ModalConfigHelper.getTeamConfig(this.onDismiss);
    this.aboutConfig = ModalConfigHelper.getAboutModalConfig(this.onDismiss);
  }

  ngOnInit() {
    this.contactUsForm.reset();
  }


  handlePrivacyActionClick = () => {
    this.modalComponent.open();
  }

  handleContactUsClick = () => {
    this.contactUsComponent.open();
  }

  handleAboutClick = () => {
    this.aboutComponent.open();
  }

  handleTeamClick = () => {
    this.teamComponent.open();
  }

  handleContactUsSubmission = () => {
    this.isFormSubmitted = true;

    if (!this.contactUsForm.valid) {
      return;
    }

    this.appService.submitContactUsDetails(this.contactUsForm.value).subscribe(resp => {
      if(resp) {
        this.uiState.setSuccess('Your details has been submitted successfully.')
      } else {
        this.uiState.setError('Unable to save your details. Please try again.')
      }
    })
  };

  getValidationMessage = (controlName: string) => {
    var controlErrors = this.contactUsForm.controls[controlName].errors;

    return getControlValidationMessage(
      controlName,
      controlErrors,
      contactUsValidationMessages
    );
  };

  canShowValidation = (controlName: string): boolean => {
    return (this.contactUsForm.controls[controlName].touched && this.contactUsForm.controls[controlName].invalid) || this.isFormSubmitted;
  }

  private onDismiss = (): Observable<boolean> => {
    this.contactUsForm.reset();
    return of<boolean>(true);
  };

}
